/**
 * Text-message (SMS) alerts: the consent a member gives, and the rules the
 * sender registration promised the carriers (docs/SMS.md). The consent text is
 * built here so the screen shows, and the server records, the same words.
 * Changing the wording means a new SMS_CONSENT_VERSION and, if it changes what
 * was registered, an update to the registration.
 */

// .2: the product name changed to the brand name, the same day the first wording was drafted.
export const SMS_CONSENT_VERSION = "2026-10-03.2";

/** Shown beside the unticked box on Settings → Notifications, and stored with each opt-in. */
export function smsConsentText(productName: string): string {
  return `Text me urgent alerts about my listings from ${productName}. Up to 10 msgs/month. Msg & data rates may apply. Reply STOP to opt out, HELP for help. Consent is not a condition of purchase.`;
}

/** Registered as "up to 10 messages a month". */
export const SMS_MONTHLY_CAP = 10;

/** One-time codes: how long one lasts, how many guesses, how soon another can be sent. */
export const SMS_CODE_MINUTES = 10;
export const SMS_CODE_ATTEMPTS = 5;
export const SMS_RESEND_SECONDS = 60;

/**
 * A US mobile number as E.164 (+1 and ten digits), or null. The sender is a
 * US toll-free number, so only US numbers can opt in for now.
 */
export function usPhoneE164(input: string): string | null {
  const digits = input.replace(/[^\d]/g, "");
  const ten = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  // NANP: area code and exchange can't start with 0 or 1.
  return /^[2-9]\d{2}[2-9]\d{6}$/.test(ten) ? `+1${ten}` : null;
}

/** "+13525550123" → "(352) •••-0123", for showing a number back without exposing it. */
export function maskPhone(e164: string): string {
  const d = e164.replace(/^\+1/, "");
  return d.length === 10 ? `(${d.slice(0, 3)}) •••-${d.slice(6)}` : "•••";
}
